// extracted by mini-css-extract-plugin
module.exports = {"dataTableFormat":"styles_dataTableFormat__V5pRq","formSpace":"styles_formSpace__3xrZK"};